import { twMerge } from 'tailwind-merge';

import { useTranslate } from '@growtherapy/i18n';
import { Body, Button } from '@growtherapy/sprout-ui';

import { useClientLogin as useBaseClientLogin } from './useClientLogin';

export type LoginButtonProps = {
  className?: string;
  useClientLogin?: typeof useBaseClientLogin;
};

/** A tiny inline, link-style login button. */
export function LoginButton({ className, useClientLogin = useBaseClientLogin }: LoginButtonProps) {
  const t = useTranslate();
  const { isClientAuthEnabled, handleLogin } = useClientLogin();

  if (!isClientAuthEnabled) return null;

  return (
    <div className={twMerge('flex items-center gap-2', className)}>
      <Body.Default emphasis>{t('telehealth-core:introRoom.haveAnAccount')}</Body.Default>
      <Button
        className='rebrand:min-h-content rebrand:typography-body-emphasis-default'
        use='link'
        onClick={handleLogin}
      >
        {t('telehealth-core:core.logIn')}
      </Button>
    </div>
  );
}
